"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLGuestTokenData = void 0;
const validators_1 = require("../../../utils/validators");
class MOLGuestTokenData {
    constructor(props) {
        Object.assign(this, props);
    }
    // ============================================================================
    // Static functions
    // ============================================================================
    static async create(molGuestTokenParams) {
        const molGuestTokenData = new MOLGuestTokenData({
            email: molGuestTokenParams.email,
            molUserId: molGuestTokenParams.molUserId,
            timestamp: molGuestTokenParams.timestamp || Date.now(),
        });
        await (0, validators_1.assertValidations)(molGuestTokenData);
        return molGuestTokenData;
    }
}
exports.MOLGuestTokenData = MOLGuestTokenData;
MOLGuestTokenData.ID_MAX_DATA_LENGTH = 512;
__decorate([
    (0, validators_1.IsEmail)(),
    __metadata("design:type", String)
], MOLGuestTokenData.prototype, "email", void 0);
__decorate([
    (0, validators_1.IsString)({ maxLength: MOLGuestTokenData.ID_MAX_DATA_LENGTH }),
    __metadata("design:type", String)
], MOLGuestTokenData.prototype, "molUserId", void 0);
__decorate([
    (0, validators_1.IsNumber)(),
    __metadata("design:type", Number)
], MOLGuestTokenData.prototype, "timestamp", void 0);
//# sourceMappingURL=MOLGuestTokenData.js.map